
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.8 15.4C29.6 15.1 23.6 7 16 7S2.4 15.1 2.2 15.4c-.3.4-.3.8 0 1.2.2.3 6.2 8.4 13.8 8.4s13.6-8.1 13.8-8.4c.3-.4.3-.8 0-1.2zM16 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"}})])
          )
        }
      }
    